import styled from 'styled-components';
import type { InsightListBlock } from '../../types';

const Wrap = styled.section`
  max-width: 46rem;
  margin: 0 auto;
  display: grid;
  gap: 0.85rem;
`;

const Title = styled.h3<{ $ink: string }>`
  margin: 0;
  font-size: 1rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: ${({ $ink }) => $ink};
`;

const UnorderedList = styled.ul<{ $mutedInk: string; $accent: string }>`
  margin: 0;
  padding: 0 0 0 1.15rem;
  display: grid;
  gap: 0.8rem;
  color: ${({ $mutedInk }) => $mutedInk};

  li::marker {
    color: ${({ $accent }) => $accent};
  }
`;

const OrderedList = styled.ol<{ $mutedInk: string; $accent: string }>`
  margin: 0;
  padding: 0 0 0 1.2rem;
  display: grid;
  gap: 0.8rem;
  color: ${({ $mutedInk }) => $mutedInk};

  li::marker {
    color: ${({ $accent }) => $accent};
    font-weight: 800;
  }
`;

const Item = styled.li`
  font-size: 1rem;
  line-height: 1.72;
`;

type ListBlockProps = {
  block: InsightListBlock;
  accent: string;
  ink: string;
  mutedInk: string;
};

export default function ListBlock({ block, accent, ink, mutedInk }: ListBlockProps) {
  const ListTag = block.style === 'ordered' ? OrderedList : UnorderedList;
  return (
    <Wrap>
      {block.title ? <Title $ink={ink}>{block.title}</Title> : null}
      <ListTag $accent={accent} $mutedInk={mutedInk}>
        {block.items.map((item) => (
          <Item key={item}>{item}</Item>
        ))}
      </ListTag>
    </Wrap>
  );
}
